var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgMovingLaunchCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Moving_BG_-_Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16325 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1500,
    x2: 16325,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1200,
    x2: 16325,
    y2: 1200
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 900,
    x2: 16325,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 600,
    x2: 16325,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 300,
    x2: 16325,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15926.83,
    x2: 15926.83,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15528.66,
    x2: 15528.66,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15130.49,
    x2: 15130.49,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14732.32,
    x2: 14732.32,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14334.15,
    x2: 14334.15,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13935.98,
    x2: 13935.98,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13537.8,
    x2: 13537.8,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13139.63,
    x2: 13139.63,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12741.46,
    x2: 12741.46,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12343.29,
    x2: 12343.29,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11945.12,
    x2: 11945.12,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11546.95,
    x2: 11546.95,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11148.78,
    x2: 11148.78,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10750.61,
    x2: 10750.61,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10352.44,
    x2: 10352.44,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9954.27,
    x2: 9954.27,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9556.1,
    x2: 9556.1,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9157.93,
    x2: 9157.93,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8759.76,
    x2: 8759.76,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8361.59,
    x2: 8361.59,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7963.41,
    x2: 7963.41,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7565.24,
    x2: 7565.24,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7167.07,
    x2: 7167.07,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6768.9,
    x2: 6768.9,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6370.73,
    x2: 6370.73,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5972.56,
    x2: 5972.56,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5574.39,
    x2: 5574.39,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5176.22,
    x2: 5176.22,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4778.05,
    x2: 4778.05,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4379.88,
    x2: 4379.88,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3981.71,
    x2: 3981.71,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3583.54,
    x2: 3583.54,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3185.37,
    x2: 3185.37,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2787.2,
    x2: 2787.2,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2389.02,
    x2: 2389.02,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1990.85,
    x2: 1990.85,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1592.68,
    x2: 1592.68,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1194.51,
    x2: 1194.51,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 796.34,
    x2: 796.34,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 398.17,
    x2: 398.17,
    y2: 1800
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16325,
    x2: 16325,
    y2: 1800
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMovingLaunchCheck);
export default __webpack_public_path__ + "static/media/bg-moving-launch-check.63bced9480699467902df5da0422261b.svg";
export { ForwardRef as ReactComponent };